export default __webpack_public_path__ + "static/project-slide-6-768-700-eaf34c2c99047aed8145605f4f5284d9.jpg";